'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _ = require('../');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatRoomCreatePage = (_temp2 = _class = function (_ChatRoomPage) {
  _inherits(ChatRoomCreatePage, _ChatRoomPage);

  function ChatRoomCreatePage() {
    var _temp, _this, _ret;

    _classCallCheck(this, ChatRoomCreatePage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _ChatRoomPage.call.apply(_ChatRoomPage, [this].concat(args))), _this), _this.onSave = function (result) {
      // console.log("this result", result);
      var _ref = result.data || {},
          response = _ref.response;

      var _ref2 = response && response.data || {},
          id = _ref2.id;

      if (id) {
        var history = _this.context.router.history;
        history.push('/chat-rooms/' + id);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ChatRoomCreatePage.prototype.componentWillMount = function componentWillMount() {
    if (!this.Renderer) {
      var View = this.props.View;
      var createChatRoomProcessor = this.context.query.createChatRoomProcessor;
      this.Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(createChatRoomProcessor)))(View);
    }

    _ChatRoomPage.prototype.componentWillMount && _ChatRoomPage.prototype.componentWillMount.call(this);
  };

  return ChatRoomCreatePage;
}(_2.default), _class.defaultProps = _extends({}, _2.default.defaultProps, {
  data: {
    object: {}
  },
  _dirty: {
    name: "",
    isPublic: false
  }
}), _temp2);
exports.default = ChatRoomCreatePage;
module.exports = exports['default'];